import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, black, cloudLight, onyxLighter} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 20,
    color: black,
  },
  titleText: {
    color: black,
  },
  noteField: {
    borderWidth: 1,
    borderColor: cloudLight,
    borderRadius: 8,
    backgroundColor: alabaster,
    marginBottom: indent * 0.4,
    marginTop: 0,
    paddingTop: indent * 0.4,
    paddingBottom: indent * 0.4,
    paddingLeft: indent,
    paddingRight: indent * 0.35,
  },
  saveNoteButton: {
    minHeight: 52,
    paddingVertical: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  characterCount: {
    textAlign: 'right',
    marginTop: 4,
    color: onyxLighter,
    fontSize: 12,
  },
});
